import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HeaderMenuButton } from 'carbon-components-react/lib/components/UIShell';
// Components
import { TopHeaderLogo, AuthGlobalToolBar } from './HeaderGlobalBar';
import { USERSROLE } from 'types';
import IUserGlobalHeader from 'components/TopHeader/IUserGlobalHeader';
import OrganisationSwitcher from 'components/OrganisationSwitcher';
import Utils from 'utilities/helper.util';
import { useSelector } from 'react-redux';
import { selectContactSupportFlag } from 'redux/user/selector';
import { ContactSupportModal } from 'components';
// Temporary block - need to delete after Helix enabled
import { RemedyForceModal } from 'components';
// Temporary block

const TopHeader: React.FC<Props & any> = (props: Props) => {
  const {
    enableHeaderGlobalBar,
    isSideNavExpanded,
    hamburgerMenuHandler
  } = props;
  const isContactSupportOpen = useSelector(selectContactSupportFlag);

  const [impersonateUserActive, setImpersonateUserActive] = useState<boolean>(
    false
  );

  useEffect(() => {
    const impersonateUser: string = sessionStorage.getItem('user') || '';
    const isActive = !Utils.isEmptyStr(impersonateUser);
    setImpersonateUserActive(isActive);
  }, []);

  return (
    <>
      {impersonateUserActive && <IUserGlobalHeader />}
      <div className="globalHeaderBody">
        <HeaderMenuButton
          className="burgerMenuButton bx--col-md-0 bx--col-lg-0"
          aria-label="Open menu"
          isCollapsible
          onClick={() => hamburgerMenuHandler()}
          isActive={!!isSideNavExpanded}
        />
        <TopHeaderLogo />
        <OrganisationSwitcher />
        {enableHeaderGlobalBar && <AuthGlobalToolBar />}
        {/*isContactSupportOpen && <ContactSupportModal /> */}
        {isContactSupportOpen && (
          <>
            {process.env.REACT_APP_REMEDY_FORCE_ENABLED === 'true' ? (
              <RemedyForceModal />
            ) : (
              <ContactSupportModal />
            )}
          </>
        )}
      </div>
      {props.children && <div className="child--wrapper">{props.children}</div>}
    </>
  );
};

const propTypes = {
  enableHeaderGlobalBar: PropTypes.bool,
  isStickyTopHeaderButton: PropTypes.bool,
  role: PropTypes.string,
  children: PropTypes.any,
  showBurgerMenuButton: PropTypes.bool,
  isSideNavExpanded: PropTypes.bool,
  hamburgerMenuHandler: PropTypes.func.isRequired,
  screenWidth: PropTypes.number
};

type Props = PropTypes.InferProps<typeof propTypes>;

TopHeader.propTypes = propTypes;

TopHeader.defaultProps = {
  enableHeaderGlobalBar: false,
  isStickyTopHeaderButton: false,
  role: USERSROLE.OTHER,
  showBurgerMenuButton: true,
  isSideNavExpanded: false,
  hamburgerMenuHandler: () => {}
};

export default React.memo(TopHeader);
